const ADMIN_BASE_URL = 'http://admin.liuwamiaoji.com'

/** 各小程序客服用户对应的管理后台页面路径（不含 query） */
const ADMIN_USER_PATH_BY_APP: Record<string, string> = {
  polls: '/admin/polls/answer/list',
  qrcode: '/admin/qrcode/base',
  dingdang_qrcode: '/admin/qrcode/base',
}

const DEFAULT_ADMIN_USER_PATH = '/admin/users/list'
const DEFAULT_APP_NAME = 'dingdang_qrcode'

/**
 * 根据用户所属小程序生成管理后台链接
 */
export function getAdminUserUrl(openid: string, appName?: string): string {
  const effectiveApp = appName || DEFAULT_APP_NAME
  const path = ADMIN_USER_PATH_BY_APP[effectiveApp] || DEFAULT_ADMIN_USER_PATH
  return `${ADMIN_BASE_URL}${path}?openid=${encodeURIComponent(openid)}`
}
